<template>
    <div class="info-window">
      <h2>{{this.title}}</h2>
      <i title="关闭" class="el-icon-close" @click="() => this.$emit('close')"></i>
      <main>
        <slot></slot>
      </main>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "标题"
        }
    }
}
</script>

<style lang="scss">
  .info-window {
    position: relative;
    height: 700px;
    width: 400px;
    background-color: var(--background-color-message);
    border: var(--border-green);
    overflow: auto;
    // padding: 10px;
    color: white;


    h2 {
      text-align: center;
      margin-bottom: 15px;
      font-size: 20px;
      background-color: var(--background-color-active);
      border-bottom: var(--border-green);
      padding: 10px 0;
    }
    .el-icon-close {
      position: absolute;
      top: 8px;
      right: 5px;
      font-size: 20px;
      cursor: pointer;
    }
  }
</style>